export const HPV_LOCATION_STORAGE_KEY = 'hpvAuthorizedLocation';

const HPV_LOCATION_MAX_AGE_MS = 10 * 60 * 1000;
const DEFAULT_LOCAL_MOCK_LOCATION = {
    latitude: 30.66,
    longitude: 117.49,
    accuracy: 50,
    coordinate_system: 'gcj02',
    source: 'local-mock'
};

const isLocalApiMockMode = () => {
    if (typeof window === 'undefined') return false;
    const localHosts = ['localhost', '127.0.0.1', '0.0.0.0'];
    return localHosts.includes(window.location.hostname) && new URLSearchParams(window.location.search).has('apiHost');
};

const readQueryMockLocation = () => {
    if (typeof window === 'undefined') return null;
    const value = new URLSearchParams(window.location.search).get('mockLocation');
    if (!value) return null;

    const [latitude, longitude] = value.split(',').map((part) => Number(part.trim()));
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
    return {
        latitude,
        longitude,
        accuracy: 50,
        coordinate_system: 'gcj02',
        source: 'query-mock'
    };
};

export const readMockHpvLocation = () => {
    const queryLocation = readQueryMockLocation();
    if (queryLocation) {
        return {
            ...queryLocation,
            timestamp: Date.now()
        };
    }

    if (!isLocalApiMockMode()) return null;
    return {
        ...DEFAULT_LOCAL_MOCK_LOCATION,
        timestamp: Date.now()
    };
};

export const readStoredHpvLocation = () => {
    try {
        const raw = localStorage.getItem(HPV_LOCATION_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.latitude || !parsed?.longitude || !parsed?.timestamp) return null;
        if (Date.now() - parsed.timestamp > HPV_LOCATION_MAX_AGE_MS) return null;
        return parsed;
    } catch (error) {
        return null;
    }
};

export const requestHpvLocation = ({maximumAge = 0} = {}) => new Promise((resolve, reject) => {
    const mockLocation = readMockHpvLocation();
    if (mockLocation) {
        localStorage.setItem(HPV_LOCATION_STORAGE_KEY, JSON.stringify(mockLocation));
        resolve(mockLocation);
        return;
    }

    if (!navigator.geolocation) {
        reject(new Error('当前浏览器不支持定位。'));
        return;
    }

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const location = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                accuracy: position.coords.accuracy,
                coordinate_system: 'wgs84',
                timestamp: Date.now()
            };
            localStorage.setItem(HPV_LOCATION_STORAGE_KEY, JSON.stringify(location));
            resolve(location);
        },
        (error) => {
            reject(error);
        },
        {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge
        }
    );
});
